import { useWorkerTimelineDays } from "./useWorkerTimelineDays";
import { useWorkerTimeDays } from "./useWorkerTimeDays";
import type { TimeDay, TimeDayBlock } from "../api/types";
import {
  dayProvenance,
  projectSplit,
  recapDay,
  type DayProvenance,
  type DayRecap,
  type ProjectSplit,
} from "../lib/dayRecap";

export interface DaySummary {
  isLoading: boolean;
  isError: boolean;
  recap: DayRecap;
  split: ProjectSplit;
  provenance: DayProvenance;
  blocks: TimeDayBlock[];
  timeDay: TimeDay | undefined;
}

/** Une journée passée d'un worker : temps calculé par TAWA, répartition par
 * projet, provenance des pointages. */
export function useDaySummary(workerUrl: string, day: string): DaySummary {
  const timeline = useWorkerTimelineDays(workerUrl, day, day);
  const timeDays = useWorkerTimeDays(workerUrl, day, day);
  const events = timeline.eventsByDay.get(day) ?? [];
  const timeDay = timeDays.daysByKey.get(day);
  return {
    isLoading: timeline.isLoading || timeDays.isLoading,
    isError: !workerUrl || timeline.isError || timeDays.isError,
    recap: recapDay(day, events, timeDay),
    split: projectSplit(timeDay),
    provenance: dayProvenance(events),
    blocks: timeDay?.blocks ?? [],
    timeDay,
  };
}
